module.exports = __webpack_public_path__ + "img/wenhao.f54ff7d3.png";